import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import axios from 'axios';
import { useAuth } from '../../../../context/AuthContext';
import SystemLoadingOverlay from './SystemLoadingOverlay';

const API_URL = "https://apiweb.hitpoly.com/ajax/scrappingController.php";

const ScrappingSystemWrapper = ({ system, activationData, onLoaded }) => {
  const { user } = useAuth();
  const [status, setStatus] = useState('vinculando');
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);
  const userId = user?.user_id || user?.id;

  useEffect(() => {
    const vincularUsuario = async () => {
      if (!userId) { setStatus('ready'); return; }

      try {
        const syncResp = await axios.post(API_URL, {
          accion: 'syncUser', user_id: userId
        });

        if (syncResp.data?.success) {
        }

        try {
          await axios.post('https://apiweb.hitpoly.com/ajax/systemTrackingController.php', {
            user_id: userId, system_id: 'scrapping', event_type: 'enter'
          });
        } catch (e) {}

        setStatus('ready');
      } catch (error) {
        setStatus('ready');
      }
    };

    vincularUsuario();
  }, [userId]);

  const showLoader = status !== 'ready' || !isIframeLoaded;

  return (
    <Box sx={{ width: "100%", height: "100%", position: "relative" }}>
      {showLoader && (
        <SystemLoadingOverlay
          title={`Cargando ${system.title}`}
          subtitle={status === 'vinculando' ? "Vinculando tu cuenta con Lead Scraping..." : "Sincronizando tu contenido..."}
          color={system.color || '#E67E22'}
        />
      )}
      <iframe
        src={activationData?.initialUrl}
        title={system.title}
        allow="clipboard-write"
        onLoad={() => {
          setIsIframeLoaded(true);
          onLoaded();
        }}
        style={{
          border: "none", 
          width: "100%", 
          height: "100%",
          display: "block"
        }}
      />
    </Box>
  );
};

export default ScrappingSystemWrapper;
